/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import axios from "axios";
import baseUrl from "..";
import { authToken, authUserID, axiosInstance } from "../axiosConfig";



// Fetches media product definitions
const getSolutionProductDefinitions = async (
    page: number,
    size: number,
    sort: any,
    order: any,
    keyword?: string,
    category?: string,
    status?: string,
    id?: string
    
    ) => {
    try {
        const response = await axiosInstance.get(
        `${baseUrl}/media_solution/list?page=${page}&size=${size}&sort=${sort}&order=${order}&status=${status}${
            keyword ? `&keyword=${keyword}` : ''
        }${
            category ? `&category_id=${category}` : ''
        }${
            id ? `&id=${id}` : ''
        }`,
        {
            headers: {
            "x-auth-token": authToken,
            "x-userid": authUserID,
            },
        }
        );

        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
        return error.response?.data;
        }
    }
    };

// Fetch Category (for dropdown)
const getCategoryList = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media/list_solution_categories?page=1&size=50&sort=id&order=desc&status=active`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

// Fetch Media Solutions (for dropdown)
const getMediaSolutions = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media/list_media_solutions?page=1&size=50&sort=id&order=desc&status=active`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};


// Create Solution Product Definition
const createSolutionProductDefinition = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/media_solution/create`,
      payload,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

// Fetch Solution Product By ID (Details screen)
const getSolutionProductById = async (productId: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media_solution/list?page=1&size=1&sort=id&order=desc&id=${productId}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

// Create Solution Product Definition
const changeSolutionProductStatus = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/media_solution/update`,
      payload,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

export const MediaSolutionProductMasterService = {
  getSolutionProductDefinitions,
  getCategoryList,
  getMediaSolutions,
  changeSolutionProductStatus,
  createSolutionProductDefinition,
  getSolutionProductById,
};